import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { axios } from 'utils/axios';

type DBVideo = {
  id: string;
  title: string;
  description?: string;
  thumbnailUrl?: string;
  videoUrl: string;
  qrCodeUrl?: string;
};

type DBVideoResponse = {
  videos: DBVideo[];
  totalPages: number;
};

const getVideos = async (page?: number): Promise<DBVideoResponse> => {
  const { data: videos } = await axios.get<DBVideoResponse>(`/ctf/videos`, {
    params: {
      page,
      limit: 12,
    },
  });
  return videos;
};

export const useVideoApi = ({
  page,
}: {
  page?: number;
}): UseQueryResult<DBVideoResponse, unknown> => {
  return useQuery({
    queryKey: [`videos-${page}`],
    queryFn: () => getVideos(page),
    retry: 1,
  });
};
